import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaTimes, FaExclamationTriangle } from 'react-icons/fa';

const EmailReminderBanner = ({ 
  userEmail, 
  autoCloseDelay = 10000, 
  profilePath = '/profile',
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (userEmail === null || userEmail === undefined) {
      setIsVisible(false);
      return;
    }
    const emailEmpty = userEmail.trim() === '';
    
    if (emailEmpty) {
      setIsVisible(true);
      
      // Auto close setelah delay tertentu
      const timer = setTimeout(() => {
        handleClose();
      }, autoCloseDelay);
      
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [userEmail, autoCloseDelay]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
      if (onClose) {
        onClose();
      }
    }, 300);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={`email-reminder-banner ${isClosing ? 'closing' : ''}`}
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        maxWidth: '400px',
        width: '90%',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        padding: '16px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        animation: isClosing 
          ? 'slideOutRight 0.3s ease-out forwards' 
          : 'slideInRight 0.3s ease-out forwards',
      }}
    >
      {/* Icon */}
      <div
        style={{
          backgroundColor: '#ffc107',
          borderRadius: '50%',
          padding: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <FaExclamationTriangle style={{ color: '#856404', fontSize: '18px' }} />
      </div>

      {/* Content */}
      <div style={{ flex: 1 }}>
        <h4
          style={{
            margin: '0 0 8px 0',
            fontSize: '14px',
            fontWeight: '600',
            color: '#856404',
          }}
        >
          Email Belum Diisi
        </h4>
        <p
          style={{
            margin: '0 0 12px 0',
            fontSize: '13px',
            color: '#856404',
            lineHeight: '1.4',
          }}
        >
          Anda belum mengisi alamat email di profil. Email diperlukan untuk menerima notifikasi terkait proses integrasi data.
        </p>
        <Link
          to={profilePath}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            backgroundColor: '#ffc107',
            color: '#856404',
            padding: '8px 16px',
            borderRadius: '4px',
            textDecoration: 'none',
            fontSize: '13px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#e0a800';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#ffc107';
          }}
          onClick={handleClose}
        >
          <FaEnvelope />
          Lengkapi Profil
        </Link>
      </div>

      {/* Close button */}
      <button
        onClick={handleClose}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '4px',
          color: '#856404',
          opacity: 0.7,
          transition: 'opacity 0.2s ease',
          flexShrink: 0,
        }}
        onMouseEnter={(e) => {
          e.target.style.opacity = 1;
        }}
        onMouseLeave={(e) => {
          e.target.style.opacity = 0.7;
        }}
        title="Tutup"
      >
        <FaTimes size={16} />
      </button>

      {/* CSS Animation Keyframes */}
      <style>
        {`
          @keyframes slideInRight {
            from {
              opacity: 0;
              transform: translateX(100%);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          @keyframes slideOutRight {
            from {
              opacity: 1;
              transform: translateX(0);
            }
            to {
              opacity: 0;
              transform: translateX(100%);
            }
          }
          
          .email-reminder-banner {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          }
        `}
      </style>
    </div>
  );
};

export default EmailReminderBanner;
